import { render, staticRenderFns } from "./NotificationsArea.vue?vue&type=template&id=4897fefc&scoped=true"
import script from "./NotificationsArea.vue?vue&type=script&lang=js"
export * from "./NotificationsArea.vue?vue&type=script&lang=js"
import style0 from "./NotificationsArea.vue?vue&type=style&index=0&id=4897fefc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897fefc",
  null
  
)

export default component.exports